import React from "react";
import { AuthProvider } from "context/AuthContext";
import RootRouter from "app/RootRouter";
import { ErrorNotification, ConfirmationModal } from "components";

// Головний компонент додатку
function App() {
  return (
    <AuthProvider>
      <RootRouter />
      <ErrorNotification />
      <ConfirmationModal />
    </AuthProvider>
  );
}

export default App;
